import { api } from '../helpers/api/api';
import { Location } from '../helpers/api/types';
import { getLocationMap } from '../layouts/Horizontal/utils';

export const fetchLocationsByClientId = async (clientId: string): Promise<Location[]> => {
  try {
    return await getLocationMap(clientId);
  } catch (error) {
    throw new Error('Failed to fetch locations');
  }
};

export const isUserAdmin = (): boolean => {
  if (!api.isUserAdministrator()) return false;

  return true;
};

export const isUserAuthenticated = (): boolean => {
  return api.isUserAuthenticated();
};
